import { render, staticRenderFns } from "./ManageExpenseAdminPlus.vue?vue&type=template&id=835cc88c&scoped=true"
import script from "./ManageExpenseAdminPlus.vue?vue&type=script&lang=js"
export * from "./ManageExpenseAdminPlus.vue?vue&type=script&lang=js"
import style0 from "./ManageExpenseAdminPlus.vue?vue&type=style&index=0&id=835cc88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835cc88c",
  null
  
)

export default component.exports